<template>
  <d-container fluid>
    <d-row>
      <d-col sm="12" md="12" lg="8">
        <d-card class="card-small">
          <d-form @submit.prevent="submit">
            <table class="table mb-0">
              <thead class="bg-grey">
                <tr>
                  <th scope="col" style="width: 40%;">Índice de Risco</th>
                  <th scope="col" style="width: 40%">Conclusão</th>
                  <th scope="col" style="width: 10%">Cor</th>
                </tr>
              </thead>
              <tbody>
              <!-- Low risk line -->
                <tr>
                <!-- Low risk index -->
                  <td class="align-middle">
                    <d-form-row class="form-input-container">
                      <span class="td-span">valor &lt;</span>
                      <d-form-input type="text" v-model="model.lowRisk" style="width:50%" placeholder="Índice de risco baixo"/>
                    </d-form-row>
                  </td>
                  <!-- Low risk conclusion -->
                  <td class="align-middle">
                    <div>
                      <d-form-input type="text" v-model="model.lowRiskConclusion" placeholder="Conclusão para índice de risco baixo"/>
                    </div>
                  </td>
                  <!-- Low risk color -->
                  <td class="align-middle">
                    <d-input
                      type="color"
                      class="feColor"
                      placeholder="Baixo risco"
                      v-model="model.lowRiskColor"
                    />
                  </td>
                </tr>
                <!-- Medium risk line -->
                <tr>
                  <!-- Medium risk index -->
                  <td class="align-middle">
                    <div>
                      <d-form-row class="form-input-container">
                        <span class="td-span">valor &gt;=</span>
                          <d-form-input class="medium-risk-input" type="text" v-model="model.mediumRisk1" placeholder="Índice médio"/>
                        <span class="td-span">e valor &lt;=</span>
                          <d-form-input class="medium-risk-input" type="text" v-model="model.mediumRisk2" placeholder="Índice médio"/>
                      </d-form-row>
                    </div>
                  </td>
                  <!-- Medium risk conclusion -->
                  <td class="align-middle">
                    <div>
                      <d-form-input type="text" v-model="model.mediumRiskConclusion" placeholder="Conclusão para índice de risco médio"/>
                    </div>
                  </td>
                  <!-- Medium risk color -->
                  <td class="align-middle">
                    <d-input
                      type="color"
                      class="feColor"
                      placeholder="Médio risco"
                      v-model="model.mediumRiskColor"
                    />
                  </td>
                </tr>
                <!-- High risk line -->
                <tr>
                  <!-- High risk index -->
                  <td class="align-middle">
                    <d-form-row class="form-input-container">
                      <span class="td-span">valor &gt;</span>
                      <d-form-input type="text" style="width: 50%" v-model="model.highRisk" placeholder="Índice de risco alto"/>
                    </d-form-row>
                  </td>
                  <!-- High risk conclusion -->
                  <td class="align-middle">
                    <div>
                      <d-form-input type="text" v-model="model.highRiskConclusion" placeholder="Conclusão para índice de risco alto"/>
                    </div>
                  </td>
                  <!-- High risk color -->
                  <td class="align-middle">
                    <d-input
                      type="color"
                      class="feColor"
                      placeholder="Alto risco"
                      v-model="model.highRiskColor"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </d-form>
        </d-card>
      </d-col>
    </d-row>
    <div class="buttons-container">
      <d-button @click.prevent="submit">
        <span class="d-none d-lg-inline">Salvar</span>
      </d-button>
    </div>
  </d-container>
</template>

<script>
import Events from '_utils/events';
import { mapActions } from 'vuex';
import SettingsService from '_services/rest/modules/settings';
import { _LOAD_MODEL_CHEMICAL_, CHEMICAL } from './SettingsModel';

export default {
  name: 'chemical-result-form',
  components: {},
  data() {
    return {
      model: { ...CHEMICAL },
    };
  },
  methods: {
    ...mapActions([
      'activeAlert',
      'getSettings',
    ]),
    checkFields() {
      const fields = ['lowRisk', 'mediumRisk1', 'mediumRisk2', 'highRisk'];
      const numberRegex = /^\d*[.,]?\d+$/;
      const invalidField = fields.find(field => {
        const value = this.model[field];
        return !numberRegex.test(value);
      });
      if (invalidField) {
        this.activeAlert({
          message: 'Os campos de índice de risco precisam ser um número.',
          theme: 'danger',
        });
        return false;
      }
      return true;
    },
    submit() {
      if (this.checkFields()) {
        SettingsService.saveOptions({ result: this.model }, 'chemical')
          .then(() => {
            this.getSettings();
            this.activeAlert({ message: 'Configurações salvas com sucesso', theme: 'success' });
          })
          .catch(error => {
            this.activeAlert({ message: `${error.message} <br/> ${error.data}`, theme: 'danger' });
          });
      }
    },
  },
  mounted() {
    Events.$on(_LOAD_MODEL_CHEMICAL_, newValue => {
      this.model = newValue;
    });
  },
};
</script>

<style>
.feColor {
  height: 37px;
  min-width: 45px;
}

.card-size {
  width: 800px;
}

.align-middle {
  vertical-align: middle;
}

.buttons-container {
  display: flex;
  justify-content: flex-start;
  margin-top: 20px;
}

.buttons-container span {
  font-size: 12px;
}

.td-span {
  margin: 0 5px;
}

.medium-risk-input {
  width: 30%;
  min-width: 100px;
}
.form-input-container {
  display: flex;
  align-items: center;
}

.bg-grey {
  background-color: #f5f5f5;
}

</style>
